import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69667e86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entry_base_contents_wrapper" }
const _hoisted_2 = { class: "entry_base_indicator_wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "entry_base_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "ご希望の勤務地を"),
  /*#__PURE__*/_createElementVNode("span", { class: "entry_base_title_text" }, "選択してください")
], -1))
const _hoisted_4 = { class: "entry_base_location" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "entry_base_location_title" }, "希望勤務地", -1))
const _hoisted_6 = { class: "entry_base_location_item_label" }
const _hoisted_7 = { class: "entry_base_location_item_label_text" }
const _hoisted_8 = {
  key: 0,
  class: "entry_base_location_item_label_required"
}
const _hoisted_9 = { class: "entry_base_location_item_input" }
const _hoisted_10 = { class: "entry_base_button" }
const _hoisted_11 = { class: "entry_base_button_prev" }
const _hoisted_12 = { class: "entry_base_button_next" }

import { ref, computed, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';
import { useField } from 'vee-validate';
import alertOnReload from '@/utils/alertOnReload';
import { getMasterDataList, Master } from '@/api/entryMasterDataEndpoint';

import store from '@/store';
import Indicator from '@/components/Indicator.vue';
import BaseSelectBox from '@/components/BaseSelectBox.vue';
import BaseButton from '@/components/BaseButton.vue';

type PrefConvert = {
  value: number;
  label: string;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'LocationView',
  setup(__props) {

const prefList = ref<Master[]>([]);
const prefListConvert = ref<PrefConvert[]>([]);

const nextCounter = computed(() => {
  return locationList.value.length + 1;
});

const LIST_COUNT_LIMIT = 4;
const isLocationListCountLimit = computed(() => {
  return nextCounter.value > LIST_COUNT_LIMIT;
});

const { value: wishwkarea1Id } = useField('wishwkarea1Id', undefined, {
  initialValue: store.getters['userRegistration/wishwkarea1Id'],
});
const { value: wishwkarea2Id } = useField('wishwkarea2Id', undefined, {
  initialValue: store.getters['userRegistration/wishwkarea2Id'],
});
const { value: wishwkarea3Id } = useField('wishwkarea3Id', undefined, {
  initialValue: store.getters['userRegistration/wishwkarea3Id'],
});
const { value: wishwkarea4Id } = useField('wishwkarea4Id', undefined, {
  initialValue: store.getters['userRegistration/wishwkarea4Id'],
});

const locationList = ref([wishwkarea1Id.value, wishwkarea2Id.value, wishwkarea3Id.value, wishwkarea4Id.value]);
// 初期化処理 locationListを後ろから検索 nullのindexを削除
for (var idx = locationList.value.length - 1; idx >= 0; idx--) {
  if (locationList.value[idx] || idx === 0) {
    break;
  }
  if (locationList.value[idx] === null) {
    locationList.value.splice(idx, 1);
  }
}

const addLocationList = () => {
  locationList.value.push('');
};

const router = useRouter();
const transitionPreviousPage = () => {
  router.push({ name: 'b11' });
};
const transitionNextPage = () => {
  store.commit('userRegistration/setWishwkarea1Id', Number(locationList.value[0]) || null);
  store.commit('userRegistration/setWishwkarea2Id', Number(locationList.value[1]) || null);
  store.commit('userRegistration/setWishwkarea3Id', Number(locationList.value[2]) || null);
  store.commit('userRegistration/setWishwkarea4Id', Number(locationList.value[3]) || null);
  router.push({ name: 'b02' });
};

onBeforeMount(async () => {
  const token = store.getters['userRegistration/token'] as string;
  if (!token) {
    router.push({ name: 'b11' });
    return;
  }

  getMasterDataList('pref')
    .then((res) => {
      prefList.value = res;
      prefListConvert.value = prefList.value.map((value) => {
        return { value: value.code, label: value.name };
      });
    })
    .catch((e) => {
      console.error(e);
    });
});
alertOnReload();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Indicator, {
          current: 2,
          max: 8
        })
      ]),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locationList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "entry_base_location_item"
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, "第" + _toDisplayString(index + 1) + "希望", 1),
              (index === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "必須"))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(BaseSelectBox, {
                options: prefListConvert.value,
                modelValue: locationList.value[index],
                "onUpdate:modelValue": ($event: any) => ((locationList.value[index]) = $event),
                hasCancelButton: "",
                placeholder: "勤務地を選択"
              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
            ])
          ]))
        }), 128)),
        (!_unref(isLocationListCountLimit))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: addLocationList,
              class: "entry_base_location_add"
            }, " ＋第" + _toDisplayString(_unref(nextCounter)) + "希望を追加 ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(BaseButton, {
            onClick: transitionPreviousPage,
            theme: "tertiary",
            type: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("戻る")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(BaseButton, {
            onClick: transitionNextPage,
            theme: "primary",
            type: "button",
            disabled: !locationList.value[0]
          }, {
            default: _withCtx(() => [
              _createTextVNode("次へ")
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ])
    ])
  ]))
}
}

})